import Colors from '../../theme/Colors';

const styles = {
  root: {
    height: 64,
    width: '100%',
    backgroundColor: Colors.lightBackground,
    boxShadow: '0px -2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px -1px 10px 0px rgba(0,0,0,0.12)',
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    padding: 16,
    alignItems: 'center',
    zIndex: 100,
    overflow: 'hidden'
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  text: {
    marginLeft: 8
  },
  iconDiscord: {
    color: Colors.white,
    fontSize: 31,
    marginTop: -4.5,
    marginLeft: 8,
    marginRight: 8
  },
  icon: {
    color: Colors.white,
    fontSize: 28
  },
  avatar: {
    height: 36,
    width: 36
  },
  centerDiv: {
    height: 2,
    width: 'calc(100% - 196px)',
    backgroundColor: Colors.grey
  }
}

export default styles;
